// TODO: This import uses around 14% of app bundle size
import {
  Exchange_v2__factory,
  ERC20__factory,
  // FixedIncomeVaultProvider_v1,
  // FixedIncomeVaultProvider_v1__factory,
  // FixedIncomeVaultProviderStateAggregator_v1,
  // FixedIncomeVaultProviderStateAggregator_v1__factory,
  // IRewardVault__factory,
  // EarningsEscrow_v2,
  EarningsEscrow_v2__factory,
} from '@katanaperps/katana-perps-sdk/typechain';
import { ContractTransactionResponse } from 'ethers';
// import { ContractTransactionResponse } from 'ethers';

export type {
  // FixedIncomeVaultProvider_v1,
  FixedIncomeVaultProviderStateAggregator_v1,
};

export {
  // TODO: needed ?
  /** USDC Ethers.js factory representing ERC20 token exported from our SDK */
  ERC20__factory,

  /** Katana Earnings Escrow Ethers.js factory exported from our SDK. */
  // EarningsEscrow__factory,

  /** Katana Vault provider Ethers.js factory */
  // TODO: vaults there are diff types like ExchangeLocalDepositAdapter_v1__factory, KatanaPerpsStargateForwarder_v1__factory
  // FixedIncomeVaultProvider_v1__factory,

  /** Latest Katana Vault vault provider Aggregator Ethers.js factory */
  // FixedIncomeVaultProviderStateAggregator_v1__factory,

  /** 2025-10 Kuma Exchange Ethers.js factory exported from our SDK */
  Exchange_v2__factory as KatanaExchange_v2__factory,

  /** Legacy 2025 Kuma Earnings Escrow Ethers.js factory exported from our SDK */
  // EarningsEscrow__factory as KumaEarningsEscrow__factory,

  /** Latest 2026 Katana Escrow for Milestone competition per round claiming exported from our SDK */
  EarningsEscrow_v2__factory,

  /** Latest Kuma Reward Vault Ethers.js factory */
  // IRewardVault__factory,

  /** Latest Kuma Vault provider Ethers.js factory */
  // FixedIncomeVaultProvider_v1__factory,
};

// TODO: vaults fake calls until it's available in the SDK again

/** Faked contract instance type until the SDK typechain bindings are available again */

export type FixedIncomeVaultProviderContract = Record<
  string,
  (...args: any[]) => Promise<any>
>;

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FixedIncomeVaultProvider_v1 {
  export type VaultBalanceForWalletSummaryStructOutput = {
    costBasis: bigint;
    initialDepositTimestampInS: bigint;
    lockedQuantity: bigint;
    owedQuantity: bigint;
    pendingDepositQuantity: bigint;
    quantityAvailableToWithdraw: bigint;
    withdrawalLimitWindowEndTimestampInS: bigint;
  };
  export type VaultConfigurationFieldsStructOutput = {
    managerWallet: string;
    effectiveTimestampInS: bigint;
    interestMultiplier: bigint;
    maximumNetDeposits: bigint;
    maximumTotalOwedQuantityAvailableMultiplierToInitiateExit: bigint;
    minimumTotalOwedQuantityAvailableMultiplierToAllowManagerWalletWithdrawal: bigint;
    minimumUnappliedDepositOrWithdrawalAgeInSToInitiateExit: bigint;
    withdrawalLimitPercentForDepositors: bigint;
    withdrawalLimitPercentForVault: bigint;
  };
  export type VaultSummaryStructOutput = {
    isDepositEnabled: boolean;
    isExited: boolean;
    isLiquidated: boolean;
    didManagerWalletWithdrawExit: boolean;
    exitedAccountValue: bigint;
    exitedAtTimestampInS: bigint;
    exitedTotalOwedQuantity: bigint;
    managerLockedQuantity: bigint;
    depositorNetDeposits: bigint;
    numDepositorWallets: bigint;
    totalLockedQuantity: bigint;
    totalOwedQuantity: bigint;
    totalPendingDepositQuantity: bigint;
    configurationFields: FixedIncomeVaultProvider_v1.VaultConfigurationFieldsStructOutput;
  };
}

// TODO: vaults - fake until `depositLocally` is exported from the SDK again
/** @deprecated */
export const depositLocally = async (..._params: any[]): Promise<string> => {
  throw new Error('Vaults not enabled');
};

/** @deprecated */
const WRITE_CALL = async (
  ..._params: any[]
): Promise<ContractTransactionResponse> => {
  throw new Error('Vaults not enabled');
};

/** @deprecated */
const READ_CALL = async <T>(..._params: any[]): Promise<T> => {
  throw new Error('Vaults not enabled');
};

// TODO: vaults
/** @deprecated */
export const FixedIncomeVaultProvider_v1__factory = {
  connect: (..._params: any[]) => {
    throw new Error('Vaults not enabled');
    return {
      MIN_INTEREST_MULTIPLIER: WRITE_CALL,
      MAX_INTEREST_MULTIPLIER: WRITE_CALL,
      MAX_MAXIMUM_NET_DEPOSITS: WRITE_CALL,
      exitWallet: WRITE_CALL,
      withdrawExit: WRITE_CALL,
      setDepositEnabled: WRITE_CALL,
      managedAccountUpgradeBlockTimestampDelayInS: READ_CALL<bigint>,
      cancelManagedAccountUpgrade: WRITE_CALL,
      finalizeManagedAccountUpgrade: WRITE_CALL,
      initiateManagedAccountUpgrade: WRITE_CALL,
      loadVaultSummary:
        READ_CALL<FixedIncomeVaultProvider_v1.VaultSummaryStructOutput>,
      loadVaultBalanceForWalletSummary:
        READ_CALL<FixedIncomeVaultProvider_v1.VaultBalanceForWalletSummaryStructOutput>,
      vaultConfigurationUpgradesByManagerWallet: READ_CALL<{
        exists: boolean;
        newVaultConfigurationFields: FixedIncomeVaultProvider_v1.VaultConfigurationFieldsStructOutput;
        blockTimestampThreshold: bigint;
      }>,
    };
  },
};

// TODO: vaults
/** @deprecated */
const _IRewardVault__factory = {
  connect: (..._params: any[]) => {
    throw new Error('Vaults not enabled');
    return {
      earned: READ_CALL<bigint>,
      operator: READ_CALL<string>,
      getReward: WRITE_CALL,
      setOperator: WRITE_CALL,
    };
  },
};

// TODO: vaults
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace FixedIncomeVaultProviderStateAggregator_v1 {
  export type LoadVaultWithdrawalQueueResultStructOutput = {
    nonce: bigint;
    depositorWallet: string;
    grossQuantity: bigint;
  };
  export type LoadVaultDepositorsResultStructOutput = {
    costBasis: bigint;
    initialDepositTimestampInS: bigint;
    owedQuantity: bigint;
  };
}

// TODO: vaults
/** @deprecated */
export const FixedIncomeVaultProviderStateAggregator_v1__factory = {
  connect: (..._params: any[]) => {
    throw new Error('Vaults not enabled');
    return {
      loadVaultConfigurations: READ_CALL<
        FixedIncomeVaultProvider_v1.VaultConfigurationFieldsStructOutput[]
      >,
      loadVaultWithdrawalQueue: READ_CALL<
        FixedIncomeVaultProviderStateAggregator_v1.LoadVaultWithdrawalQueueResultStructOutput[]
      >,
      loadVaultDepositorsByManagerWallet: READ_CALL<
        FixedIncomeVaultProviderStateAggregator_v1.LoadVaultDepositorsResultStructOutput[]
      >,
      loadVaultDepositorsByDepositorWallet: READ_CALL<
        FixedIncomeVaultProviderStateAggregator_v1.LoadVaultDepositorsResultStructOutput[]
      >,
    };
  },
};
